/** @format */

import React, { useEffect, useState } from "react";
import SellerBanner from "./SellerBanner";
import DynamicCarousel from "./DynamicCarousel";
import Link from "next/link";
import { Row, Col } from "antd";
import Icon from "@ant-design/icons";
import { connect } from "react-redux";
import { getCurrencySymbol } from "../../utils/getCurrencySymbol";
import { registerToApp } from "../AuthWithKeycloak";
import { useRouter } from "next/router";
import { useCookies } from "react-cookie";
// import { useKeycloak } from "@react-keycloak/ssr";
import sellerList from "../../public/filestore/freeShippingSellers.json";
import { checkoutPLPClickEE, checkoutPLPProductImpressionEE, checkoutPDPClickEE } from "../../utils/GTMDataLayer";
import atcPlpIcon from "../../public/filestore/atcPlpIcon";
import addedtcPlpIcon from "../../public/filestore/addedtcPlpIcon";

function ProductCard(props) {
  const [cookies, setCookie] = useCookies([""]);
  const [nameclicked,setNameclicked]=useState(false)

  const handleClickname =()=>{

    setNameclicked(true);
  }
 

  const router = useRouter();

  console.log('currency', props.currencyDetails);
  // const { keycloak } = useKeycloak();
  let isAuthenticated = props.isAuthenticated;
  const getConvertedCurrency = (baseAmount) => {
    let { convertToCurrency = "", rates = [] } = props.currencyDetails;
    return Number.parseFloat(baseAmount * rates[convertToCurrency]).toFixed(2);
  };

  const signUp = (e) => {
    // registerToApp(keycloak, { currentPath: router.asPath });
    router.push('/signup');
    e.stopPropagation();
    e.preventDefault();
  };
  const productclick = () => {
    try {
      const {
        productName,
        productNameV1,
        productType,
        fulfillmentModel,
        // sellerCode,
        // minimumOrderQuantity,
        id,
        key,
        // freeShippingEligible,
      } = props.data;
      const { convertToCurrency = "" } = props.currencyDetails;
      let idNum = '';
      if(props.data.articleId){
        idNum = props.data.articleId
      }else if(id){
        idNum = id.split("::")[1];
      }
      if((props.pageName === 'PDP') || (props.pageName === 'fromSameSeller')){
        checkoutPDPClickEE(
          {
            position: props.position + 1,
            name: productName || productNameV1 || "",
            id: idNum,
            price: "",
            variant: "",
            category: productType || "",
          },
          convertToCurrency,
          props.widgetName || props.pageId || ""
        );
      }else{
        checkoutPLPClickEE(
          {
            position: key + 1,
            name: productName || productNameV1 || "",
            id: idNum,
            price: "",
            variant: "",
            category: props.data.l1Name ? props.data.l1Name  : props.data.l2Name ? props.data.l2Name : props.data.l3Name || "",
          },
          convertToCurrency,
          props.pageName === 'search-listing' ? 'search-listing' : (props.pageId || "")
        );
      }
    } catch (err) {}
  };

  const plpProductTrack = () => {
    try{
      if(JSON.parse(sessionStorage.getItem('stateViewedProductsArray')).length > 0){
      let items = JSON.parse(sessionStorage.getItem('stateViewedProductsArray'));
        // setDummyState(true);
        let productsData = [];
        let productIdsArray = [];
        if(props.slp_content.length > 0){
          productIdsArray = props.slp_content.map((e) => e.id.replace('PRODUCT::', '')*1);
        }
        // let dataToLoop = slp_content.slice(offset);
        for(let i = 0; i < props.slp_content.length; i++){
          let productId = props.slp_content[i].id.replace("PRODUCT::", "");
          if(items.find(e => e === productId * 1)){
            let buffer = props.slp_content[i];
            let temp = {
              index: productIdsArray.indexOf(productId * 1),
              name: buffer.productName || productNameV1 || "",
              id: productId,
              price: buffer.exFactoryPrice || "",
              category: buffer.productType || "",
            };
            productsData.push(temp);
          }
        }
        // update state for already sent products to GA
        // let stateProducts = sessionStorage.getItem('sentProducts') && JSON.parse(sessionStorage.getItem('sentProducts')).length > 0 ? JSON.parse(sessionStorage.getItem('sentProducts')) : [] ;
        // // console.log('stateProducts', stateProducts);
        // let info1 = Array.from(new Set(stateProducts.concat(items)));
        // sessionStorage.setItem('sentProducts', JSON.stringify(info1));
        // setSentProducts(info1);
        // sessionStorage.removeItem('stateViewedProductsArray');
        // console.log('productsData', productsData);
        if(productsData && productsData.length > 0){
          const { convertToCurrency = "" } = props.currencyDetails;
          // debugger
          checkoutPLPProductImpressionEE(
            productsData,
            convertToCurrency,
            "product-listing"
          );
        }
      }
    }catch (err) {}
  };
  
  let productDetails = props?.data || {};
  let {
    pageId = "",
    pageName = "",
    isMobile = false,
    userProfile = {},
    selectedProductId = "",
    selectProduct,
    currencyDetails = {},
    sellerId = "",
    recentlyViewed = false,
    fromSameTheme = false,
    fromSameSeller = false,
    fromSimilar = false,
    isLoading
  } = props;
  let {
    orgName = "",
    brandName = "",
    companyDescription = "",
    bannerImage = {},
    brandLogo = {},
    productTypeDescs = [],
    publicCategoryMedias = [],
    values = [],
    orderTypes = [],
    id = "",
    // vanityId = "",
    exFactoryPrice = "",
    exfactoryListPrice = "",
    mediaUrls = [],
    // minimumOrderQuantity = "",
    // moqUnit = "",
    productName = "",
    productNameV1="",
    productType = "",
    fulfillmentModel="",
    colorFamily = [],
    showSPLP = "",
    visibleTo = "",
    sellerCode = "",
    freeShippingEligible = false,
    categoryDescs = [],
    articleId = "",
    imageUrl = "",
    // landedPriceManual1 = "",
    // landedPriceManual2 = "",
    // landedPriceManual3 = "",
    // landedPriceManual4 = "",
    // landedPriceManual5 = "",
    tradeDiscountInfo = {},
    salesInfoTag = [],
    isIncollections = false,
    suggestedRetailPrice = 0
  } = productDetails;
  
  if(typeof freeShippingEligible == 'string' && String(freeShippingEligible).toLowerCase() == "true"){
    freeShippingEligible = true;
  }else{
    if(pageName === 'search-listing'){
      freeShippingEligible = false;
    }
  }
  
  let salesInfo = {};
  if(pageName == 'search-listing'){
    if (salesInfoTag) {
      if (salesInfoTag == "Best Seller") {
        salesInfo["BEST SELLER"] = 1;
      } else if (salesInfoTag == "Trending") {
        if (Object.keys(salesInfo).length <= 0) {
          salesInfo["TRENDING"] = 1;
        } else {
          salesInfo["TRENDING"] = 2;
        }
      } else if (salesInfoTag == "New") {
        if (Object.keys(salesInfo).length <= 0) {
          salesInfo["New"] = 1;
        } else {
          if (salesInfo.TRENDING) {
            salesInfo["New"] = 2;
          } else {
            salesInfo["New"] = 3;
          }
        }
      }
    }
  }else{
    if (salesInfoTag && salesInfoTag.length > 0) {
      if (salesInfoTag.find((elem) => elem && elem.trim() == "Best Seller")) {
        salesInfo["BEST SELLER"] = 1;
      } else if (salesInfoTag.find((elem) => elem && elem.trim() == "Trending")) {
        if (Object.keys(salesInfo).length <= 0) {
          salesInfo["TRENDING"] = 1;
        } else {
          salesInfo["TRENDING"] = 2;
        }
      } else if (salesInfoTag.find((elem) => elem && elem.trim() == "New")) {
        if (Object.keys(salesInfo).length <= 0) {
          salesInfo["New"] = 1;
        } else {
          if (salesInfo.TRENDING) {
            salesInfo["New"] = 2;
          } else {
            salesInfo["New"] = 3;
          }
        }
      }
    }
  }
  
  //if imageUrl is null on search-listing page, put a placeholder image
  if(!imageUrl && mediaUrls){
    imageUrl=mediaUrls

  }else{

    imageUrl = process.env.NEXT_PUBLIC_URL + "/placeholder.png";
  }


  let salesTagName = "";
  Object.keys(salesInfo).forEach((key) => {
    if (salesInfo[key] === 1) {
      salesTagName = key;
    }
  });

  let { convertToCurrency = "", ipDetails = {} } = currencyDetails || {};

  let displayPrice = exFactoryPrice;

  let discount = 0;
  if (tradeDiscountInfo && tradeDiscountInfo.type === "PERCENTAGE") {
    discount = tradeDiscountInfo.value.toFixed(0);
  } else if (tradeDiscountInfo && tradeDiscountInfo.type === "ABSOLUTE") {
    discount = ((tradeDiscountInfo.value / exFactoryPrice) * 100).toFixed(0);
  }

  let { country_code = "" } = ipDetails || {};

  let {
    profileType = "",
    verificationStatus = "",
    profileId = "",
  } = userProfile || {};
  if (profileType === "SELLER") {
    profileId = profileId.replace("SELLER::", "");
  }
  let accessLocked = true;
  let showPrice = true;
  if (
    (profileType === "BUYER" && verificationStatus === "VERIFIED") ||
    (profileType === "BUYER" && verificationStatus === "IN_PROGRESS") ||
    (profileType === "SELLER" && profileId === sellerId)
  ) {
    accessLocked = false;
  }

  if (visibleTo === "ALL" || visibleTo === "GLOBAL") {
    accessLocked = false;
  }

  if (visibleTo === "SPECIFIC") {
    accessLocked = false;
  }

  if (
    !props.isAuthenticated ||
    (profileType === "BUYER" && verificationStatus === "ON_HOLD") ||
    (profileType === "BUYER" && verificationStatus === "REJECTED") ||
    (profileType === "SELLER" && profileId !== sellerId)
  ) {
    showPrice = false;
  }
  let productNameSC;
  if(props.data.productName){

  productNameSC=  props.data && props.data.productName &&
    productName.toLowerCase().charAt(0).toUpperCase() +
    productName.toLowerCase().slice(1);
  }
  else{
    productNameSC=  props.data && props.data.productNameV1 &&
      productNameV1.toLowerCase().charAt(0).toUpperCase() +
      productNameV1.toLowerCase().slice(1);


  }

  let productTypeDisp = (productType === "RTS" || productType === "Ready to ship") &&
                  (fulfillmentModel?.trim() === "JIT" ||
                    fulfillmentModel?.trim() === "DROPSHIP")
                    ? "In Stock"
                    : (productType === "RTS" || productType === "Ready to ship")
                    ? "Ready to ship"
                    : (productType === "ERTM")
                    ? "ready to make"
                    : "make to order"

  if (pageId === "seller-product-listing" || pageId === "product-listing") {
    id = id.replace("PRODUCT::", "") || articleId;
    let linkTo = `/product/${id}`;

    if (accessLocked) {
      linkTo = "/";
    }
    let getshortenid = function(id){
      try {
        if(id){
          return id.split("::")[1];
        }else{
          return "";
        }
      } catch (error) {
        console.warn("error in id manupluation :"+error);
        return "";
      }
    }
    
    let sellerLink = `/seller/${sellerCode}/all-categories`;
    return (
      <Link href={linkTo} className="product-card products-on-listing" target={isMobile ? "_parent" : "_blank"} prefetch={false}>
        {/*<a target={isMobile ? "_parent" : "_blank"} className="products-on-listing">*/}
          <div
            onClick={(e) => {
              if (accessLocked) {
                selectProduct(id);
                e.stopPropagation();
                e.preventDefault();
              }
              productclick();
              plpProductTrack();
              if(props.captureClickedProduct){
                props.captureClickedProduct(id);
              }
            }}
            onContextMenu={(e) => {
              if (accessLocked) {
                e.preventDefault();
              }
            }}
          >
            <DynamicCarousel
              items={1}
              id={pageId}
              showArrows={true}
              // data={(pageName == 'search-listing' || fromSimilar ) ? [imageUrl] : mediaUrls}
              data={(pageName == 'search-listing' || fromSimilar ) ? mediaUrls : mediaUrls}
              mediaUrls={mediaUrls}
              productName={productName}
              productNameV1={productNameV1}
              userProfile={userProfile}
              selectedProductId={selectedProductId}
              productId={id}
              sellerId={sellerId}
              visibleTo={visibleTo}
              image={imageUrl || mediaUrls}
              discount={productDetails?.tradeDiscountInfo || null}
              isAuthenticated={props.isAuthenticated}
              salesTagName={salesTagName}
              productTypeDisp={productTypeDisp}
              pageName={pageName}
              fromSameSeller={fromSameSeller}
              fromSameTheme={fromSameTheme}
              fromSimilar={fromSimilar}
              isLoading={isLoading}
              nameclicked={nameclicked}
            />
            <div
              className={
                (id === "product-listing" || id === "seller-product-listing") &&
                accessLocked &&
                props.isAuthenticated
                  ? "product-list-details qa-mar-top-05 qa-font-san qa-fs-12 lock-section"
                  : "product-list-details qa-mar-top-05 qa-font-san qa-fs-12"
              }
              // style={{marginTop:"20px"}}
            >
              <Row className={pageName === "PDP" ? "qa-tc-white" : "qa-tc-white row-height-35px"}>
                <Col onClick={()=> handleClickname()} span={(sellerList.includes(sellerCode) ||
                    freeShippingEligible || props.fromPDP || fromSameTheme || fromSameSeller) ? 16 : 24}>
                  <h3 
  className="qa-tc-white qa-fs-12 qa-fw-sb qa-lh pdname-text-ellipsis qa-font-san"
  style={{ 
    minHeight: "40px",  // Ensures consistent height for product names
    lineHeight: "1.2",  // Adjusts spacing between lines
    overflow: "hidden", // Prevents excessive text overflow
    display: "-webkit-box",
    WebkitLineClamp: 2,  // Limits product name to 2 lines
    WebkitBoxOrient: "vertical"
  }}
>
  {productNameSC}
</h3>

                </Col>
                { (!(props.fromPDP || fromSameSeller || fromSameTheme) && freeShippingEligible) &&
                  <Col span={7} className="qa-txt-alg-rgt">
                      <div className="qa-offer-text">FREE shipping</div>
                  </Col>
                }
                {/* { (props.fromPDP) ?  
                  <Col span={8} className="qa-txt-alg-rgt pdp-producttype-tag">
                      <div className="qa-offer-text">{productType}11</div>
                  </Col>
                  : (fromSameSeller || fromSameTheme) ?
                  <Col span={8} className="qa-txt-alg-rgt pdp-producttype-tag">
                      <div className="qa-offer-text">{productTypeDisp}22</div>
                  </Col>
                  : null
                } */}
              </Row>
              <Row className="qa-tc-white">
                <Col md={20} xs={20}>
                {!props.isAuthenticated && (
                  <Col span={24}>
                    <div className="qa-tc-white sign-up-plp" id={`${id}`}>
                      {((country_code !== "IN" && visibleTo === "GLOBAL") || (visibleTo === "SPECIFIC") || ((pageId === "product-listing" || pageId == "seller-product-listing") && props?.data?.key < 6)) ? (
                        <span className="qa-tc-white listing-price-section qa-font-san" id={`${id}`}>
                        {productDetails.tradeDiscountInfo ? (
                          <span className="qa-fs-12">
                            <super className="qa-fw-sb">
                              {getCurrencySymbol(convertToCurrency)}{" "}
                              {getConvertedCurrency(exfactoryListPrice)}{" "}
                            </super>
                            <super style={{ textDecoration: "line-through" }}>
                              {getCurrencySymbol(convertToCurrency)}{" "}
                              {getConvertedCurrency(displayPrice)}
                            </super>
                          </span>
                        ) : (
                          <span className="qa-fw-sb qa-fs-12">
                            {getCurrencySymbol(convertToCurrency)}{" "}
                            {getConvertedCurrency(displayPrice)}
                          </span>
                        )}{" "}
                        {(pageId == "product-listing" ||
                          pageId == "seller-product-listing") &&
                          discount > 0 && (
                            <span className="new-plp-td qa-fw-b">
                              {discount}% Off
                            </span>
                          )}
                      </span>
                      ) : (
                        <span className="qa-cursor" onClick={(e) => signUp(e)}>
                          <span className="qa-fs-13 qa-tc-white sign-up-ano abcd qa-font-san">
                            Sign up to view prices
                          </span>

                          <svg
                            style={{
                              marginLeft: "3px",
                              verticalAlign: "sub",
                            }}
                            width="12"
                            height="15"
                            viewBox="0 0 19 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.56437 4.08666L7.34698 5.30405L9.60785 7.56492H0.738281V9.30405H9.60785L7.34698 11.5649L8.56437 12.7823L12.9122 8.43449L8.56437 4.08666ZM16.3905 14.5214H9.43393V16.2606H16.3905C17.347 16.2606 18.1296 15.478 18.1296 14.5214V2.34753C18.1296 1.39101 17.347 0.608398 16.3905 0.608398H9.43393V2.34753H16.3905V14.5214Z"
                              fill="#D9BB7F"
                            />
                          </svg>
                        </span>
                      )}
                    </div>
                  </Col>
                )}
                {!accessLocked && props.isAuthenticated && showPrice && (
                  <>
                    <Col xs={24} md={16} className="price-discount-section">
                      {displayPrice !== null && displayPrice > 0 && (
                        <span className="qa-tc-white listing-price-section qa-font-san" id={`${id}`}>
                          {productDetails.tradeDiscountInfo ? (
                            <span className="qa-fs-12">
                              <super className="qa-fw-sb">
                                {getCurrencySymbol(convertToCurrency)}{" "}
                                {getConvertedCurrency(exfactoryListPrice)}{" "}
                              </super>
                              <super style={{ textDecoration: "line-through" }}>
                                {getCurrencySymbol(convertToCurrency)}{" "}
                                {getConvertedCurrency(displayPrice)}
                              </super>
                            </span>
                          ) : (
                            <span className="qa-fw-sb qa-fs-12">
                              {getCurrencySymbol(convertToCurrency)}{" "}
                              {getConvertedCurrency(displayPrice)}
                            </span>
                          )}{" "}
                          {(pageId == "product-listing" ||
                            pageId == "seller-product-listing") &&
                            discount > 0 && (
                              <span className="new-plp-td qa-fw-b">
                                {discount}% Off
                              </span>
                            )}
                        </span>
                      )}
                    </Col>
                    {/*<Col xs={8} className="qa-txt-alg-rgt qa-mar-top-05">
                      {colorFamily && colorFamily.length > 1 && (
                        <div>+colors available</div>
                      )}
                    </Col>*/}
                  </>
                )}
                {pageId === "product-listing" && (
                  <>
                    {/* {suggestedRetailPrice && suggestedRetailPrice > 0 ?
                      <div className="new-plp-td qa-fw-b qa-fs-12">
                        MSRP : {getCurrencySymbol(convertToCurrency)}{" "} {getConvertedCurrency(suggestedRetailPrice)}
                      </div>
                      :
                      null
                    } */}
                    <div
                      className="explore-more-sellers qa-sm-color qa-cursor qa-font-san"
                      onClick={(e) => {
                        router.push(sellerLink);
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      Explore more by this seller
                    </div>
                  </>
                )}
                </Col>
                <Col span={4}  className={pageName === "PDP" ? "qa-mar-btmmmm-15" : "qa-mar-top-15"}>
                  {((pageId === "product-listing"  && pageName === 'product-listing' || 'search-listing') || (pageId === "seller-product-listing" && pageName === "SPLP")) && (
                    <div className="qa-txt-alg-rgt save-to-collection" onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          props.setCollectionName(id, sellerCode);
                          props?.setCurrentCorrency(getCurrencySymbol(convertToCurrency) || "USD");
                          props?.setCollectionPrice(getConvertedCurrency(displayPrice) || 0);
                        }
                      }
                    >
                      {isIncollections ? 
                        <Icon
                          component={addedtcPlpIcon}
                          className="add-to-collection-plp elem-prop"
                          style={{
                            width: "12px",
                            // verticalAlign: "middle",
                          }}
                        />
                        :
                        <Icon
                          component={atcPlpIcon}
                          className="add-to-collection-plp"
                          style={{
                            width: "12px",
                            // verticalAlign: "middle",
                            
                          }}
                        />
                      }
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </div>
        {/*</a>*/}
      </Link>
    );
  } else {
    let linkTo = `/seller-profile/${id.replace("HOME::SELLER::", "")}`;
    if (showSPLP === "true" || showSPLP === true || recentlyViewed) {
      id = id.replace("HOME::SELLER::", "");
      let categoryName = "all-categories";
      linkTo = `/seller/${id}/${categoryName}`;
    }
    return (
      <Link href={linkTo} className="product-card" target={isMobile ? "_parent" : "_blank"}>
        {/*<a target={isMobile ? "_parent" : "_blank"}>*/}
          {pageId === "seller-listing" && (
            <SellerBanner
              orgName={brandName || orgName}
              companyDescription={companyDescription}
              bannerImage={bannerImage}
              brandLogo={brandLogo}
              title="Seller Profile"
            />
          )}
          <DynamicCarousel
            items={1}
            id={pageId}
            showArrows={true}
            data={publicCategoryMedias}
            userProfile={userProfile}
            image={imageUrl || mediaUrls}
            discount={productDetails?.tradeDiscountInfo || null}
            isAuthenticated={props.isAuthenticated}
            fromSameSeller={fromSameSeller}
            fromSameTheme={fromSameTheme}
            productTypeDisp={productTypeDisp}
            nameclicked={nameclicked}
          />
          <div className="seller-list-details">
            <div
              style={{
                lineHeight: "130%",
                marginBottom: "5px",
                height: "31px",
              }}
              className="qa-text-2line"
            >
              <span className="qa-tc-white">
                <span className="qa-tc-white qa-fw-sb">Product range: </span>
              </span>{" "}
              <span className="qa-text-body">
                {productTypeDescs.join(", ") || categoryDescs.join(",")}
              </span>
            </div>
            <div>
              <span className="qa-tc-white qa-fw-sb">
                {orderTypes.includes("RTS")
                  ? "Ready to ship orders"
                  : "Custom orders"}
              </span>
            </div>
            <div
              style={{
                textOverflow: "ellipsis",
                width: "100%",
                display: "block",
                overflow: "hidden",
              }}
            >
              {values.map((list, i) => {
                return (
                  <span key={i} className="seller-hash-tag">
                    #{list.replace(/_/gi, "")}
                  </span>
                );
              })}
            </div>
          </div>
        {/*</a>*/}
      </Link>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currencyDetails: state.currencyConverter,
    userProfile: state.userProfile.userProfile,
  };
};

export default connect(mapStateToProps, null)(ProductCard);
